export enum MqttTopic {
  //Start of the topics that should be removed
  GUI_NOTIFICATION = "gui-notification",
  LICENSE_EXPIRED = "license-expired",
  SESSION_EXPIRED = "session-expired",
  ICT_GATEWAY = "ict-gateway",
  GMON_RESULTS_AVAILABLE = 'gmonResultsAvailable',
  PV_RESULTS_AVAILABLE = 'pvResultsAvailable',
  GMON_ERROR = 'gmonError',
  PV_ERROR = 'pvError',
  LC_RESULTS_AVAILABLE = 'lcResultsAvailable',
  LC_ERROR = 'lcError',
  LA_RESULTS_AVAILABLE = 'laResultsAvailable',
  LA_ERROR = 'laError',
  RPA_RESULTS_AVAILABLE = 'rpaResultsAvailable',
  RPA_ERROR = 'rpaError',
  GPLAN_RESULTS_AVAILABLE = 'gpResultsAvailable',
  GPLAN_ERROR = 'gpError',
  DFH_GATEWAY = "ict-gateway",
  FAULTLOCATIONS = "faultlocations",
  FAULTLOCATIONS_ERROR = "faultlocationsError",
  APPLICATIONS_PROGRESS_MESSAGE = "applicationsProgressMessage",
  GPLAN_SCENARIO_CREATED = "gpScenarioCreated",
  ALARM_GENERATED = "alarmGenerated",
  LIVE_MONITORING_RESULTS_READY ="lmResultsReady",
  //End of the topics that should be removed
  INFOMQTTTOPIC = "info",
  ERROMQTTTOPIC = "error"
}

